import e from '@/lang/fr/error'

export default {
  contingent_hotel: {
    show: {
      page_title: 'Fiche hôtel',
      map: 'Carte'
    },
    create: {
      page_title: 'Ajouter un hôtel contingent'
    },
    edit: {
      page_title: 'Modifier un hôtel contingent'
    },
    mass_edit: {
      title: 'Modification contingent par période',
      success: 'Les contingents ont bien été modifiés'
    },
    form: {
      700: e.error[700],
      10: e.error[10]
    }
  },
  hotel_hotel: {
    show: {
      page_title: '',
      map: 'Carte'
    }
  }
}
